import { useState, useCallback } from 'react';

const ActionView = (legalViews, defaultView = legalViews[0]) => {
	const [view, setView] = useState(defaultView);
	const setViewFunction = useCallback(newView => setView(legalViews.find(view => view === newView)), [legalViews]);
	return [view, setViewFunction];
};

export default ActionView;
